<template>
  <div class="container mt-5">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <div class="card m-5">
          <div class="card-header">
            <h1 class="text-center">Connexion</h1>
          </div>
          <div class="card-body">
            <form @submit.prevent="login">
              <div class="mb-3">
                <label for="email" class="form-label">Courriel</label>
                <input v-model="email" type="email" class="form-control" id="email" placeholder="Email" required />
              </div>
              <div class="mb-3">
                <label for="password" class="form-label">Mot de passe</label>
                <input v-model="password" type="password" class="form-control" id="password" placeholder="Mot de passe" required />
              </div>
              <div class="d-grid gap-2">
                <button type="submit" class="btn btn-primary" :disabled="isLoading">
                  <span v-if="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  <span v-else>Connexion</span>
                </button>
                <router-link to="/register" class="btn btn-outline-secondary">
                  Créer mon compte
                </router-link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import authService from '../services/authService';

export default {
  data() {
    return {
      email: '',
      password: '',
      isLoading: false
    };
  },
  methods: {
    async login() {
      this.isLoading = true; // Active le spinner
      try {
        const token = await authService.login({ email: this.email, password: this.password });
        await this.$store.dispatch('auth/login', { token }); // met à jour la navbar
        this.$router.push('/');
      } catch (error) {
        console.error('Login failed:', error);
      } finally {
        this.isLoading = false; // Désactive le spinner
      }
    }
  }
};
</script>

<style scoped>
/* Ajoute des styles personnalisés si nécessaire */
</style>
